import {
  Header as RACHeader,
  Menu as RACMenu,
  MenuItem as RACMenuItem,
  type MenuItemProps as RACMenuItemProps,
  type MenuProps as RACMenuProps,
  MenuSection as RACMenuSection,
  type MenuSectionProps as RACMenuSectionProps,
  MenuTrigger as RACMenuTrigger,
  type MenuTriggerProps as RACMenuTriggerProps,
  Popover as RACPopover,
  type PopoverProps as RACPopoverProps,
  Separator as RACSeparator,
  type SeparatorProps as RACSeparatorProps,
} from "react-aria-components";

export interface MenuProps<T extends object> extends RACMenuProps<T> {}
export interface MenuItemProps extends RACMenuItemProps {}
export interface MenuPopoverProps extends RACPopoverProps {}
export interface MenuSectionProps<T extends object> extends RACMenuSectionProps<T> {}
export interface MenuSeparatorProps extends RACSeparatorProps {}
export interface MenuTriggerProps extends RACMenuTriggerProps {}
export type MenuHeaderProps = React.ComponentPropsWithoutRef<typeof RACHeader>;

export function Menu<T extends object>(props: MenuProps<T>) {
  return <RACMenu {...props} />;
}

export function MenuItem(props: MenuItemProps) {
  return <RACMenuItem {...props} />;
}

export function MenuPopover(props: MenuPopoverProps) {
  return <RACPopover {...props} />;
}

export function MenuSection<T extends object>(props: MenuSectionProps<T>) {
  return <RACMenuSection {...props} />;
}

export function MenuSeparator(props: MenuSeparatorProps) {
  return <RACSeparator {...props} />;
}

export function MenuTrigger(props: MenuTriggerProps) {
  return <RACMenuTrigger {...props} />;
}

export function MenuHeader(props: MenuHeaderProps) {
  return <RACHeader {...props} />;
}
